// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the ApiServices.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
import BaseApi from './BaseApi';
import SaveEmailTemplateDTO from '../models/SaveEmailTemplateDTO';
import PreviewEmailTemplateDTO from '../models/PreviewEmailTemplateDTO';
import EmailTemplateDTO from '../models/EmailTemplateDTO';
import ResultDTO from '../models/ResultDTO';

export class AdminEmailTemplatesApiService extends BaseApi {

  // get: api/admin/email-templates/${typeId}
  public get(typeId: number): Promise<EmailTemplateDTO> {
    let url = `api/admin/email-templates/${typeId}`;

    url = url.replace(/null|undefined/gi, '');
    return this.SendRequest<any, EmailTemplateDTO>(null, 'get', url, true, false);
  }

  // post: api/admin/email-templates
  public save(model: SaveEmailTemplateDTO): Promise<ResultDTO> {
    let url = `api/admin/email-templates`;

    url = url.replace(/null|undefined/gi, '');
    return this.SendRequest<any, ResultDTO>(model, 'post', url, true, false);
  }

  // post: api/admin/email-templates/${typeId}/preview
  public preview(typeId: number, model: PreviewEmailTemplateDTO): Promise<string> {
    let url = `api/admin/email-templates/${typeId}/preview`;

    url = url.replace(/null|undefined/gi, '');
    return this.SendRequest<any, string>(model, 'post', url, true, false);
  }

  // post: api/admin/email-templates/${typeId}/test
  public sentTestEmail(typeId: number): Promise<void> {
    let url = `api/admin/email-templates/${typeId}/test`;

    url = url.replace(/null|undefined/gi, '');
    return this.SendRequest<any, void>(null, 'post', url, true, false);
  }
}
var service = new AdminEmailTemplatesApiService();
export default service;
